/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_WorksInputs */

const en_vc_status_works = /** @type {(inputs: Vc_Status_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already usable`)
};

const zh_vc_status_works = /** @type {(inputs: Vc_Status_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已经能用`)
};

/**
* | output |
* | --- |
* | "Already usable" |
*
* @param {Vc_Status_WorksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_works = /** @type {((inputs?: Vc_Status_WorksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_WorksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_works(inputs)
	return zh_vc_status_works(inputs)
});
export { vc_status_works as "vc.status.works" }